// extracted by mini-css-extract-plugin
export default {"container":"CH-z","disabled":"DH-z","bgBlack":"EH-z","content":"FH-z","countdown":"GH-z","topCaption":"HH-z","topHeading":"IH-z","heading":"JH-z","copy":"KH-z"};